import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import IconButton from '@mui/material/IconButton';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        paddingLeft: 10,
    },
    bubble: {
        position: 'absolute',

        // need to move all the colors into theme
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        borderColor: theme.palette.secondary.main,
        borderWidth: 1.4,
        borderStyle: 'solid',

        // normal size
        left: -30,
        fontWeight: 600,
        width: 30,
        height: 30,
        fontSize: 14,

        '&.bubbleup': {
            transition: 'top 0.420s',
        },

        '& svg.MuiSvgIcon-root': {
            width: '0.7em',
            height: '0.7em',
        },

        // selected size
        '&.selected': {
            left: -37.5,
            width: 45,
            height: 45,
            fontSize: 20,
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.background.default,
            '& svg.MuiSvgIcon-root': {
                width: '1em',
                height: '1em',
            }
        },

        // hover size
        '&:hover': {
            '&:not(.selected)': {
                left: -32.5,
                width: 37.5,
                height: 37.5,
                fontSize: 17,
                '& svg.MuiSvgIcon-root': {
                    width: '0.85em',
                    height: '0.85',
                }
            }
        },

        // disabled
        '&.disabled': {
            opacity: 0.5,
        }
    }
}));

const BubbleTabs = (props) => {
    const classes = useStyles();
    // bubble up the selected tab but otherwise preserve order
    const tags = (props.tabs || []).map((t, index) => ({ ...t, index }));

    // it's not really a bubble sort
    const bubbleSort = () => {
        if (props.static) return () => {};
        return (a, b) => a.key === props.selected ? -1 : b.key === props.selected ? 1 : 0;
    };

    const getStyle = (t, i) => {
        if (props.static) return { top: `${i * 45 + (t.key === props.selected ? -7 : 0)}px` };
        return { top: `${i * 45 + (i > 0 ? 15 : 0)}px` };
    };

    // style={{ top: `${i * 50 + (t.key !== props.selected ? 15 : 0)}px` }}
    return (
        <div className={classes.root}>
            {tags.sort(bubbleSort())
                .map((t, i) => {
                    return (
                        <IconButton
                            title={t.title}
                            key={t.key}
                            disabled={t.disabled}
                            size='small'
                            color='primary'
                            aria-label={t.title}
                            className={clsx(classes.bubble, {
                                selected: t.key === props.selected,
                                disabled: t.disabled,
                                bubbleup: !props.static,
                            })}
                            style={getStyle(t, i)}
                            onClick={() => props.onClick && props.onClick(t.key)}>
                            {t.icon}
                        </IconButton>
                    );
                })}
            { props.children }
        </div>
    );
};

BubbleTabs.propTypes = {
    tabs: PropTypes.array,
    selected: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
    static: PropTypes.bool,
};

export default BubbleTabs;
